var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './main.scss';
var SingleHorizontalCard = function (_a) {
    var _b = _a.data, author = _b.author, title = _b.title, bio = _b.bio, card_img = _b.card_img;
    return (_jsx("div", __assign({ className: "single-horizontal flex-row" }, { children: _jsxs("div", __assign({ className: "sh-card" }, { children: [_jsx("div", __assign({ className: "sh-card__image-containter absolute" }, { children: _jsx("img", { src: card_img.src, alt: card_img.alt, className: "sh-card__image" }, void 0) }), card_img.src),
                _jsxs("div", __assign({ className: "sh-card__details" }, { children: [_jsx("div", { className: "sh-card__author", dangerouslySetInnerHTML: { __html: author } }, void 0),
                        _jsx("div", { className: "sh-card__title", dangerouslySetInnerHTML: { __html: title } }, void 0)] }), void 0),
                _jsx("div", { className: "sh-card__bio", dangerouslySetInnerHTML: { __html: bio } }, void 0)] }), void 0) }), void 0));
};
export default SingleHorizontalCard;
